<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="form" :model="listQuery" inline>
        <el-form-item prop="bank_name">
          <el-input v-model="listQuery.bank_name" placeholder="请输入支行名称" clearable @change="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item prop="parent_id">
          <el-select v-model="listQuery.parent_id" placeholder="请选择上级银行" filterable clearable @change="SearchData" @keyup.enter.native="SearchData">
            <el-option
              v-for="item in bankData"
              :key="item.id"
              :label="item.bank_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button v-auth="'BranchBank.create'" class="action-item" type="primary" icon="el-icon-plus" @click="HandleCreate">添加</el-button>
        <el-button v-auth="'BranchBank.delete'" class="action-item" type="danger" icon="el-icon-delete" @click="BatchDelete">删除</el-button>
        <!-- <el-button v-auth="'BranchBank.export'" class="action-item" icon="el-icon-download" type="primary" @click="exportPopup = true"> 导出 </el-button> -->

      </el-button-group>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <!--列开始-->
      <el-table-column type="selection" fixed></el-table-column>
      <!-- <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" /> -->
      <el-table-column fixed align="center" width="160" prop="bank_name" show-overflow-tooltip label="银行名称 "> </el-table-column>
      <el-table-column align="center" prop="parent_text" width="160" show-overflow-tooltip label="上级银行"> </el-table-column>
      <el-table-column align="center" prop="legal_person_name" width="160" label="法人真实姓名 "> </el-table-column>
      <el-table-column align="center" prop="legal_person_id_number" width="165" label="法人身份证号 "> </el-table-column>
      <el-table-column align="center" prop="legal_person_phone" width="160" label="法人手机号 "> </el-table-column>
      <el-table-column align="center" prop="business_license_number" width="170" label="营业执照号 "></el-table-column>
      <el-table-column align="center" prop="business_license_image" width="160" label="营业执照图片 ">
        <template scope="scopes">
          <el-image style="width: 100px;height: 100px;" :src="scopes.row.business_license_image" :preview-src-list="[scopes.row.business_license_image]"></el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="user_account" width="160" label="负责人账号 "> </el-table-column>
      <el-table-column align="center" prop="user_real_name" width="160" label="负责人姓名 "> </el-table-column>
      <el-table-column align="center" prop="province" width="160" label="所属省 ">
        <template slot-scope="scopes">
          <span>{{ scopes.row.province_text }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="city" width="160" label="所属市 ">
        <template slot-scope="scopes">
          <span>{{ scopes.row.city_text }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="area" width="160" label="所属区/县">
        <template slot-scope="scopes">
          <span>{{ scopes.row.area_text }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="detailed_address" show-overflow-tooltip width="160" label="详细地址 "> </el-table-column>
      <el-table-column align="center" prop="create_time" width="160" label="创建时间"> </el-table-column>
      <el-table-column fixed="right" align="center" prop="" label="操作" width="350" class-name="action">
        <template slot-scope="scopes">
          <el-button v-auth="'BranchBank.view'" icon="el-icon-tickets" type="warning" size="mini" @click="HandleView(scopes.row)">查看</el-button>
          <el-button v-auth="'BranchBank.update'" icon="el-icon-edit" type="primary" size="mini" @click="HandleUpdate(scopes.row)">编辑</el-button>
          <el-button v-auth="'BranchBank:bankuser'" icon="el-icon-s-custom" type="info" size="mini" @click="HandleUser(scopes.row)">成员</el-button>
          <el-button v-auth="'BranchBank.delete'" icon="el-icon-delete" type="danger" size="mini" @click="RowDelete(scopes.row)">删除</el-button>

        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!--弹窗编辑/新增窗体-->
    <el-dialog :title="dialogStatus=='create'?'新增银行信息':'编辑银行信息'" :visible.sync="dialogFormVisible">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="110px" style="width: 100%;">
        <el-divider content-position="left">银行信息</el-divider>
        <el-form-item label="银行名称" prop="bank_name">
          <el-input v-model="temp.bank_name" placeholder="请输入银行名称" />
        </el-form-item>
        <el-form-item label="所属市行" prop="parent_id">
          <el-select v-model="temp.parent_id" style="width: 100%;" placeholder="请选择所属市行">
            <el-option
              v-for="item in bankData"
              :key="item.id"
              :label="item.bank_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运营区域" prop="operating_region">
          <el-cascader v-model="temp.operating_region" placeholder="请选择运营区域" :disabled="!temp.parent_id" :options="options" :props="props" clearable style="width: 100%;"></el-cascader>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="证件类型" prop="license_type">
              <el-select v-model="temp.license_type" placeholder="请选择证件类型" style="width: 95%;">
                <el-option v-for="item in dictionary['bank_card_type']" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业执照号" prop="business_license_number">
              <el-input v-model="temp.business_license_number" show-word-limit placeholder="请输入营业执照号" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="营业执照图片" prop="business_license_image">
          <FileList v-model="temp.business_license_image" :limit="1" type="image" />
        </el-form-item>
        <el-form-item label="支行地址" prop="province">
          <el-cascader v-model="temp.province" placeholder="请选择支行地址" :options="addressOptions" clearable style="width: 100%;"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="detailed_address">
          <el-input v-model="temp.detailed_address" placeholder="请输入详细地址" />
        </el-form-item>
        <el-form-item label="显示排序" prop="order_no">
          <span slot="label">
            <el-tooltip
              content="排序号越小越靠前"
              placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
            显示排序
          </span>
          <el-input-number
            v-model="temp.order_no"
            controls-position="right"
            :min="0"
          />
        </el-form-item>
        <el-divider content-position="left">法人信息</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="法人证件类型" prop="legal_person_id_type">
              <el-select v-model="temp.legal_person_id_type" placeholder="请选择法人证件类型" style="width: 98%;">
                <el-option v-for="item in dictionary['card_type']" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人真实姓名" prop="legal_person_name">
              <el-input v-model="temp.legal_person_name" placeholder="请输入法人真实姓名" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="法人身份证号" prop="legal_person_id_number">
              <el-input v-model="temp.legal_person_id_number" placeholder="请输入法人身份证号" style="width: 98%;" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人手机号" prop="legal_person_phone">
              <el-input v-model="temp.legal_person_phone" placeholder="请输入法人手机号" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="身份证正面照" prop="legal_person_id_front_image">
              <FileList v-model="temp.legal_person_id_front_image" :limit="1" type="image" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证反面照" prop="legal_person_id_back_image">
              <FileList v-model="temp.legal_person_id_back_image" :limit="1" type="image" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-form-item label="上级银行id" prop="parent_id">
          <el-input v-model="temp.parent_id" />
        </el-form-item>
        <el-form-item label="所有上级银行id" prop="all_parent_id">
          <el-input v-model="temp.all_parent_id" />
        </el-form-item> -->
        <el-divider content-position="left">管理人信息</el-divider>
        <el-row>
          <el-col :span="8">
            <el-form-item label="用户账号" prop="user_account">
              <el-input v-model="temp.user_account" placeholder="请输入用户账号" style="width: 98%;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="真实姓名" prop="user_real_name">
              <el-input v-model="temp.user_real_name" placeholder="请输入真实姓名" style="width: 98%;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电话号码" prop="user_phone_number">
              <el-input v-model="temp.user_phone_number" placeholder="请输入电话号码" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="身份证号码" prop="user_id_number">
          <el-input v-model="temp.user_id_number" placeholder="请输入身份证号码" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
    <!-- 查看详情弹窗 -->
    <el-dialog title="支行详情" :visible.sync="dialogViewFormVisible">
      <el-form ref="UserdataForm" :model="Usertemp" label-position="left" label-width="110px" style="width: 100%;">
        <el-divider content-position="left">银行信息</el-divider>
        <el-form-item label="银行名称" prop="bank_name">
          <el-input v-model="Usertemp.bank_name" disabled placeholder="请输入银行名称" />
        </el-form-item>
        <el-form-item label="所属省行" prop="parent_id">
          <el-select v-model="Usertemp.parent_id" disabled style="width: 100%;" placeholder="请选择所属省行">
            <el-option
              v-for="item in bankData"
              :key="item.id"
              :label="item.bank_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运营区域" prop="operating_region">
          <el-cascader v-model="Usertemp.operating_region" placeholder="请选择运营区域" disabled :options="options" :props="props" clearable style="width: 100%;"></el-cascader>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="证件类型" prop="license_type">
              <el-select v-model="Usertemp.license_type" disabled placeholder="请选择证件类型" style="width: 95%;">
                <el-option v-for="item in dictionary['bank_card_type']" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业执照号" prop="business_license_number">
              <el-input v-model="Usertemp.business_license_number" disabled show-word-limit placeholder="请输入营业执照号" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="营业执照图片" prop="business_license_image">
          <FileList v-model="Usertemp.business_license_image" :limit="1" type="image" />
        </el-form-item>
        <el-form-item label="市行地址" prop="province">
          <el-cascader v-model="Usertemp.province" placeholder="请选择市行地址" disabled :options="addressOptions" clearable style="width: 100%;"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="detailed_address">
          <el-input v-model="Usertemp.detailed_address" disabled placeholder="请输入详细地址" />
        </el-form-item>
        <el-form-item label="显示排序" prop="order_no">
          <span slot="label">
            <el-tooltip
              content="排序号越小越靠前"
              placement="top"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
            显示排序
          </span>
          <el-input-number
            v-model="Usertemp.order_no"
            disabled
            controls-position="right"
            :min="0"
          />
        </el-form-item>
        <el-divider content-position="left">法人信息</el-divider>
        <el-row>
          <el-col :span="12">
            <el-form-item label="法人证件类型" prop="legal_person_id_type">
              <el-select v-model="Usertemp.legal_person_id_type" disabled placeholder="请选择法人证件类型" style="width: 98%;">
                <el-option v-for="item in dictionary['card_type']" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人真实姓名" prop="legal_person_name">
              <el-input v-model="Usertemp.legal_person_name" disabled placeholder="请输入法人真实姓名" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="法人身份证号" prop="legal_person_id_number">
              <el-input v-model="Usertemp.legal_person_id_number" disabled placeholder="请输入法人身份证号" style="width: 98%;" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人手机号" prop="legal_person_phone">
              <el-input v-model="Usertemp.legal_person_phone" disabled placeholder="请输入法人手机号" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="身份证正面照" prop="legal_person_id_front_image">
              <FileList v-model="Usertemp.legal_person_id_front_image" disabled :limit="1" type="image" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证反面照" prop="legal_person_id_back_image">
              <FileList v-model="Usertemp.legal_person_id_back_image" disabled :limit="1" type="image" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-form-item label="上级银行id" prop="parent_id">
          <el-input v-model="temp.parent_id" />
        </el-form-item>
        <el-form-item label="所有上级银行id" prop="all_parent_id">
          <el-input v-model="temp.all_parent_id" />
        </el-form-item> -->
        <el-divider content-position="left">管理人信息</el-divider>
        <el-row>
          <el-col :span="8">
            <el-form-item label="用户账号" prop="user_account">
              <el-input v-model="Usertemp.user_account" disabled placeholder="请输入用户账号" style="width: 98%;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="真实姓名" prop="user_real_name">
              <el-input v-model="Usertemp.user_real_name" disabled placeholder="请输入真实姓名" style="width: 98%;" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电话号码" prop="user_phone_number">
              <el-input v-model="Usertemp.user_phone_number" disabled placeholder="请输入电话号码" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="身份证号码" prop="user_id_number">
          <el-input v-model="Usertemp.user_id_number" disabled placeholder="请输入身份证号码" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogViewFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/bank_info' // 和数据交互相关写在api 方便复用
import Indexapi from '@/api/index' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
// import WangEditor from '@/components/WangEditor'
import FileList from '@/components/attachment/FileList'
import dict_data from '@/api/system/dict_data'

export default {
  name: 'BranchBank',
  components: { Pagination, FileList },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    var validatebusiness_license_number = (rule, value, collback) => {
      const licenseRegex = /^[0-9]{15}$|^[0-9]{18}$/ // 15位或18位数字
      if (!licenseRegex.test(value)) {
        collback(new Error('请输入15或18位数字营业执照号码'))
      } else {
        collback()
      }
    }
    return {
      // api接口方法
      api,
      // 校验
      rules: {
        'bank_name': { required: true, message: '请输入银行名称', trigger: 'blur,change' },
        'parent_id': { required: true, message: '请选择所属市行', trigger: 'blur,change' },
        'operating_region': { required: true, message: '请选择运营区域', trigger: 'blur,change' },
        'license_type': { required: true, message: '请选择证件类型', trigger: 'blur,change' },
        'business_license_number': { required: true, validator: validatebusiness_license_number, trigger: 'blur,change' },
        'province': { required: true, message: '请输入银行地址', trigger: 'blur,change' },
        'detailed_address': { required: true, message: '请输入银行详细地址', trigger: 'blur,change' }
      },
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        type: 3, // 银行等级
        order: 'DESC', // 默认排序方式,
        sort: 'id'
      },
      // 字典参数
      dictionary: [],
      // 字典参数
      // 地区树
      options: [],
      addressOptions: [],
      props: { multiple: true },
      // 银行列表
      bankData: [],
      // 表单锁
      lock: false,
      old_operating_region: [],
      // 详情查看弹窗
      Usertemp: {},
      dialogViewFormVisible: false,
      user_operating_region: []
    }
  },
  watch: {
    'temp.parent_id': function(newValue, oldValue) {
      if (newValue !== oldValue && newValue !== '') {
        this.temp.operating_region = ''
        this.getAreaTree(newValue)
      }
    },
    'Usertemp.parent_id': function(newValue, oldValue) {
      if (newValue !== oldValue && newValue !== '') {
        this.Usertemp.operating_region = ''
        this.getAreaTree(newValue)
      }
    }
  },
  created() {
    this.loadData()
    // 获取银行的地址
    this.getAddress()
    // 查询上级银行
    this.getParentBank()
    // 获取字典表数据
    dict_data
      .Drop({
        sort: 'sort',
        order: 'asc',
        isPaginator: false,
        dict_code: 'bank_card_type,card_type,'
      })
      .then((response) => {
        this.dictionary = response.data
      })
  },
  methods: {
    // 详情查看
    HandleView(row) {
      this.Usertemp = JSON.parse(JSON.stringify(row)) // copy obj
      this.user_operating_region = this.Usertemp.operating_region
      this.dialogViewFormVisible = true
    },
    // 添加用户
    HandleUser(row) {
      this.$router.push({
        path: '/bank_info/bank_user',
        query: {
          bank_id: row.id
        }
      })
    },
    // 新增
    HandleCreate() {
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.resetFields()
        }
      })
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
    },
    // 显示编辑窗体
    HandleUpdate(row) {
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.resetFields()
        }
      })
      this.temp = JSON.parse(JSON.stringify(row)) // copy obj
      this.old_operating_region = this.temp.operating_region
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
    },
    // 获取上级银行
    getParentBank() {
      api.getParentBank({ type: 2 }).then((response) => {
        this.bankData = response.data
      })
    },
    // 获取市行经营区域
    getAreaTree(city) {
      Indexapi.getAreaList({ area: city }).then((response) => {
        this.options = response.data
        this.temp.operating_region = this.old_operating_region
        this.old_operating_region = []
        // 详情运营区域
        this.Usertemp.operating_region = this.user_operating_region
        this.user_operating_region = []
      })
    },
    // 获取银行的地址
    getAddress() {
      Indexapi.getAreaTree({ level: 4 }).then((response) => {
        this.addressOptions = response.data
      })
    },
    // 表单提交
    ConfirmData() {
      if (!this.lock) {
        this.lock = true
      }
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          const formData = JSON.parse(JSON.stringify(this.temp))
          // 运营区域
          formData.operating_region = this.temp.operating_region
          formData.operating_region_array = this.temp.operating_region.join(',')
          // 全部上级
          formData.all_parent_id = this.temp.parent_id
          // 所在省市区
          formData.province = this.temp.province[0]
          formData.city = this.temp.province[1]
          formData.area = this.temp.province[2]
          if (this.dialogStatus === 'create') {
            api.Create(formData).then(() => {
              this.loadData()
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '操作成功',
                type: 'success',
                duration: 2000
              })
              setTimeout(() => {
                this.lock = false
              }, 1000)
            }).catch(error => {
              console.log(error)
              this.lock = false
            })
          } else {
            api.Update(formData).then(() => {
              this.loadData()
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '操作成功',
                type: 'success',
                duration: 2000
              })
              setTimeout(() => {
                this.lock = false
              }, 1000)
            }).catch(error => {
              console.log(error)
              this.lock = false
            })
          }
        }
      })
    },
    resetTemp() {
      this.options = []
      this.temp = {
        id: undefined,
        order_no: 99999,
        type: 3,
        bank_name: '',
        operating_region: '',
        license_type: '',
        business_license_number: '',
        province: '',
        city: '',
        area: '',
        detailed_address: '',
        legal_person_name: '',
        legal_person_id_number: '',
        legal_person_phone: '',
        parent_id: '',
        all_parent_id: '',
        user_account: '',
        user_real_name: '',
        user_phone_number: '',
        user_id_number: ''
      }
    }
  }
}
</script>
<style scoped>
.el-tooltip__popper{
    max-width:30%;
    padding-bottom: 5px!important;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 15;
    -webkit-box-orient: vertical;

  }
  .el-tooltip__popper,.el-tooltip__popper.is-dark{
    background:rgb(48, 65, 86) !important;
    color: #fff !important;
    line-height: 24px;
  }

</style>
